<template>
    <knowledge-library :show-search-results-heading="showSearchResultsHeading" :location-link="locationLink"></knowledge-library>
</template>

<script>
    import KnowledgeLibrary from '@/components/KnowledgeLibrary/knowledge-library'

    export default {
        components: {
            KnowledgeLibrary
        },

        props: {
            locationLink: {
                default: null,
                type: String
            },

            showSearchResultsHeading: {
                default: false,
                type: Boolean
            }
        }
    }
</script>